import React, {Component} from 'react'
import {Modal, Form, Row, Col, Input, Button, Table} from 'antd'
import customerManagementAPI from '../../../apis/customerManagement'
import {DeleteOutlined} from '@ant-design/icons'
import {alertMessage} from '../../../utils'
import {withTranslation} from 'react-i18next'

const {TextArea} = Input

class EditModal extends Component {
  formRef = React.createRef()
  state = {
    contacts: [],
    identities: []
  }

  componentDidMount() {
    const {id} = this.props
    customerManagementAPI.getInfoAction(id).then(res => {
      let result = res.data.data
      this.formRef.current.setFieldsValue({
        customer: result.customer,
        customerName: result.customerName,
        parentCustomer: result.parentCustomer,
        region: result.region,
        address: result.address,
        Contacts: result.contacts,
        Identities: result.identities,
        ipListString: result.ipListString
      })
      // this.setState({
      //   contacts: result.contacts,
      //   identities: result.identities
      // })

    })
  }

  handleOk = () => {
    const {handleCancel, handleSearch, id} = this.props

    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        id,
        customer: fieldsValue.customer,
        customerName: fieldsValue.customerName,
        parentCustomer: fieldsValue.parentCustomer,
        region: fieldsValue.region,
        address: fieldsValue.address,
        contacts: fieldsValue.Contacts,
        identities: fieldsValue.Identities,
        ipListString: fieldsValue.ipListString
      }
      customerManagementAPI.addAction(params).then(res => {
        handleCancel('editModalVisible')
        handleSearch()
        alertMessage.success(res.data.message).then()
      })
    }).catch(() => { })
  }

  handleDel = (target, index) => {
    if (this.state[target].length > 1) {
      let origin = this.state[target]
      origin.splice(index, 1)
      this.setState({
        [target]: [...origin]
      })
    }
  }

  render() {
    const {editModalVisible, handleCancel, t} = this.props
    return (
      <>
        <Modal
          title={`${t(`general.edit`)} ${t(`customerManagement.customer`)}`}
          width="70%"
          closable={true}
          onCancel={() => { handleCancel('editModalVisible') }}
          visible={editModalVisible}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={() => { handleCancel('editModalVisible') }}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addMapping" layout="vertical">
            <Row gutter={[10, 0]}>
              <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                <Form.Item name="customer" label={t(`customerManagement.customer`)} rules={[{
                  required: true,
                  message: `${t(`general.pleaseEnter`)} ${t(`customerManagement.customer`)} ${t(`general.withoutSpecialChats`)}`,
                  pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                }]}>
                  <Input maxLength={100} disabled placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                <Form.Item name="customerName" label={t(`customerManagement.customerName`)} rules={[{
                  required: false,
                  message: `${t(`general.pleaseEnter`)} ${t(`customerManagement.customerName`)} ${t(`general.withoutSpecialChats`)}`,
                  pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                <Form.Item name="parentCustomer" label={t(`customerManagement.parentCustomer`)} rules={[{
                  required: false,
                  message: `${t(`general.pleaseEnter`)} ${t(`customerManagement.parentCustomer`)} ${t(`general.withoutSpecialChats`)}`,
                  pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                <Form.Item name="region" label={t(`customerManagement.region`)} rules={[{
                  required: false,
                  message: `${t(`general.pleaseEnter`)} ${t(`customerManagement.region`)} ${t(`general.withoutSpecialChats`)}`,
                  pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12} span={12}>
                <Form.Item name="address" label={t(`customerManagement.address`)} rules={[{
                  required: false,
                  message: `${t(`general.pleaseEnter`)} ${t(`customerManagement.address`)} ${t(`general.withoutSpecialChats`)}`,
                  pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                }]}>
                  <TextArea rows={2} placeholder={t(`general.pleaseEnter`)} allowClear/>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12} span={12}>
                <Form.Item name="ipListString" label={t(`customerManagement.ipList`)}>
                  <TextArea rows={2} placeholder={t(`general.pleaseEnter`)} allowClear/>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[10, 0]}>
              <Form.List name="Contacts">
                {(fields, {add, remove}) => (
                  <>
                    <Col span={20} style={{fontSize: '18px'}}>{t(`customerManagement.contacts`)}</Col>
                    <Col span={4} style={{textAlign: 'right'}}>
                      <Button key="add" type="danger" onClick={() => { add() }}>{t(`general.add`)}</Button>
                    </Col>
                    <Col span={24}>
                      <Table dataSource={fields} pagination={false} style={{margin: '10px 0'}}>
                        <Table.Column title={t(`customerManagement.name`)} dataIndex="contactName" key="contactName" render={(text, row) => {
                          return (
                            <Form.Item name={[row.name, 'contactName']} rules={[{
                              required: false,
                              message: `${t(`general.pleaseEnter`)} ${t(`customerManagement.customerName`)} ${t(`general.withoutSpecialChats`)}`,
                              pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                            }]}>
                              <Input/>
                            </Form.Item>
                          )
                        }}/>
                        <Table.Column title={t(`customerManagement.email`)} dataIndex="email" key="email" render={(text, row) => {
                          return (
                            <Form.Item name={[row.name, 'email']} rules={[{
                              required: false,
                              message: `${t(`general.pleaseEnter`)} ${t(`customerManagement.email`)} ${t(`general.withoutSpecialChats`)}`,
                              pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                            }]}>
                              <Input/>
                            </Form.Item>
                          )
                        }}/>
                        <Table.Column title={t(`customerManagement.phone`)} dataIndex="phone" key="phone" render={(text, row) => {
                          return (
                            <Form.Item name={[row.name, 'phone']} rules={[{
                              required: false,
                              message: `${t(`general.pleaseEnter`)} ${t(`customerManagement.phone`)} ${t(`general.withoutSpecialChats`)}`,
                              pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                            }]}>
                              <Input/>
                            </Form.Item>
                          )
                        }}/>
                        <Table.Column title={t(`customerManagement.position`)} dataIndex="position" key="position" render={(text, row) => {
                          return (
                            <Form.Item name={[row.name, 'position']} rules={[{
                              required: false,
                              message: `${t(`general.pleaseEnter`)} ${t(`customerManagement.position`)} ${t(`general.withoutSpecialChats`)}`,
                              pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                            }]}>
                              <Input/>
                            </Form.Item>
                          )
                        }}/>
                        <Table.Column title={t(`customerManagement.note`)} dataIndex="note" key="note" render={(text, row) => {
                          return (
                            <Form.Item name={[row.name, 'note']} rules={[{
                              required: false,
                              message: `${t(`general.pleaseEnter`)} ${t(`customerManagement.note`)} ${t(`general.withoutSpecialChats`)}`,
                              pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                            }]}>
                              <Input/>
                            </Form.Item>
                          )
                        }}/>
                        <Table.Column align="center" title={t(`general.action`)} key="Action" render={(text, row, index) => (
                          <Button type="link" onClick={() => remove(index)} icon={<DeleteOutlined/>} title={t(`general.delete`)}/>
                        )}/>
                      </Table>
                    </Col>
                  </>
                )}
              </Form.List>
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(EditModal)
